/**
 * Created by aleksandr on 29.11.14.
 */

function result_request(data){
    for (key in data){
        if (key == 'alert'){

        }else{
            if(data[key]['method'] == 'append'){
                jQuery(key).append(data[key]['data']);
            }else if(data[key]['method'] == 'replace'){
                jQuery(key).html(data[key]['data']);
            }else if(data[key]['method'] == 'remove'){
                jQuery(key).remove();
            }
            else{

            }
            if(data[key]['removeclass']){
                jQuery(key).removeClass(data[key]['removeclass']);
            }
        }
    }
    for (key in data){
            if(data[key]['class']){
                jQuery(key).addClass(data[key]['class']);
            }
            if(data[key]['attr']){
                for (key_attr in data[key]['attr']){
                    var opt = {};
                    opt[key_attr] = data[key]['attr'][key_attr];
                    jQuery(key).attr(opt);
                }
            }
    }
}

function update_counts(content_type, pk, cart_pk){
    var quantity = jQuery('#quantity_'+cart_pk).val();
    var csrfmiddlewaretoken = jQuery('input[name=csrfmiddlewaretoken]').val();
    var url = '/cart/'
    jQuery.ajax({
        url: url,
        type: "POST",
        data: 'csrfmiddlewaretoken='+csrfmiddlewaretoken+'&content_type='+content_type+'&object_id='+pk+'&quantity='+quantity,
        success: function(response) {
            result_request(response);
        },
        error: function(response) {
            alert(response);
        }
    });
}

function send_form(form_selector, url, goal_ym){
    var form_data = jQuery(form_selector).serialize();
    jQuery.ajax({
        url: url,
        type: "POST",
        data: form_data,
        success: function(response) {
            result_request(response);
            if (goal_ym) {
                if(response.code == 200){
                    ym(goal_ym.counter, 'reachGoal', goal_ym.goal);
                }
            }
        },
        error: function(response) {
            alert(response);
        }
    });
}

function get_ajax_data(url){
    jQuery.ajax({
        url: url,
        type: "GET",
        data: 'pk_f=12',
        success: function(response) {
            result_request(response);
        },
        error: function(response) {
            console.log(response);
        }
    });
}

if (jQuery('.integer-slider').length){
        jQuery(".integer-slider").ionRangeSlider({
            onFinish: function (data) {
                var rblock = 'result_counter_' + data.input.attr('id');

                $('.filter-container .filter-default').show();

                $('#from_' + data.input.attr('id')).val($('#from_' + data.input.attr('id'))                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             .attr('rel') + ':' + data.from);
                $('#to_' + data.input.attr('id')).val($('#to_' + data.input.attr('id')).attr('rel') + ':' + data.to);
                render_facets('#products_facets', data.input.attr('rel'), rblock);
            }
        });
    }

$('.filter-group .checkbox input').on('ifChanged', function (event) {
    var rblock = 'result_counter_' + jQuery(this).attr('id');
    $('.filter-container .filter-default').show();
    render_facets('#products_facets', jQuery(this).attr('rel'), rblock);
});

jQuery('.filter-group .checkbox input').change(function () {

});

function render_facets(form_id, url, result_block){
    var form_data = jQuery(form_id).serialize();
    jQuery.ajax({
        url: url,
        type: "GET",
        data: form_data+'&result_block='+result_block,
        success: function(response) {
            jQuery('.absolute_result_block').remove();
            result_request(response);
        },
        error: function(response) {
            console.log(response);
        }
    });
}